import styled from "@emotion/styled";

const Main = styled.main`
    width: 77.5vw;
`

export default Main;